import React, { useCallback } from "react";
import { useIntl } from "react-intl";
import { Form, Upload } from "antd";

import { saveData } from "../../../modules/saveFile";
import IconButton from "../../app/generic/iconButton";
import { error, success } from "../../../modules/messages";

const maxFiles = 1,
  accept = "text/plain";

export default function ClientFile({
  all,
  name,
  currentFiles,
  max = maxFiles,
  onSetCurrentFiles,
}) {
  const intl = useIntl();

  const handleFileSubmit = useCallback(
    ({ file, onError, onProgress, onSuccess, ...rest }) => {
      try {
        setTimeout(() => onProgress({ percent: 1 }), 250);
        setTimeout(() => onProgress({ percent: 50 }), 500);
        setTimeout(() => onProgress({ percent: 100 }), 700);
        setTimeout(() => onSuccess({ success: true }), 900);
      } catch (error) {
        onError(error);
      }
    },
    []
  );
  const handleDownload = useCallback((file) => {
    saveData(file.originFileObj, file.filename, file.type);
  }, []);

  const handleChange = useCallback(
    (info) => {
      const { status, response } = info.file;
      const list = info.fileList.filter((f) => all || f.type === accept);
      onSetCurrentFiles(list.length > 0 ? [list[0]] : []);
      if (!all && info.file.type !== accept) {
        error(
          intl.formatMessage({
            id: "document.onlyTxt",
            defaultMessage: "Je povoleno nahrávat pouze .txt soubory",
          })
        );
      }
      if (status === "done") {
        if (response.success) {
          success(
            intl.formatMessage(
              {
                id: "document.upload.success",
                defaultMessage: "Příloha {name} byla úspěšně nahrána.",
              },
              { name: info.file.name }
            ),
            10
          );
        } else {
          error(
            intl.formatMessage(
              {
                id: "document.upload.response",
                defaultMessage:
                  "Při zpracování přílohy nastala chyba: {message}.",
              },
              { message: response.message }
            ),
            10
          );
        }
      } else if (status === "error") {
        error(
          intl.formatMessage(
            {
              id: "document.upload.error",
              defaultMessage: "Nahrávání přílohy {name} selhalo.",
            },
            { name: info.file.name }
          ),
          10
        );
      } else if (
        !info.event &&
        info.fileList &&
        status === "uploading" &&
        info.fileList.length > max
      ) {
        error(
          intl.formatMessage(
            {
              id: "document.upload.exceed",
              defaultMessage:
                "Maximální počet příloh je {max}, pokud si přejete nahrát další, smažte předchozí.",
            },
            { max }
          ),
          10
        );
      }
    },
    [all, max, intl, onSetCurrentFiles]
  );

  return (
    <Form.Item>
      <Upload
        fileList={currentFiles}
        onChange={handleChange}
        onDownload={handleDownload}
        customRequest={handleFileSubmit}
        accept={all ? undefined : accept}
        showUploadList={{ showDownloadIcon: true, showRemoveIcon: true }}
      >
        <IconButton
          icon="upload"
          shape="none"
          text={intl.formatMessage(
            {
              id: "document.upload.button",
              defaultMessage: "Nahrát přílohu (maximum {max})",
            },
            { max }
          )}
        />
      </Upload>
    </Form.Item>
  );
}
